import styled from "styled-components";
import { theme } from "../theme";

type SliderComponentProps = {
  background: boolean;
}

const CalculatorContainer = styled.div<SliderComponentProps>`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  flex: 1 0 0;
  border-radius: var(--Medium, 12px);
  background: ${({ background }) => background ? "#F8F8F9" : "transparent"};
  text-align: center;
`;

const SliderWrapper = styled.div`
  position: relative;
  width: 100%;
`;

type SliderValueProps = {
  position: number;
  easeIn: boolean;
}

const SliderValue = styled.div<SliderValueProps>`
  position: absolute;
  top: -20px;
  left: ${({ position }) => `calc(${position}% - ${56 * position / 100}px)`};
  font-size: 16px;
  font-weight: 600;
  color: ${theme.colors.strong};
  transition: ${({ easeIn }) => easeIn ? "left 0.1s ease-out" : "none"};
`;

const SliderComponent = styled.input`
  width: 100%;
  margin: 16px 0;
  appearance: none;
  height: 6px;
  border-radius: 4px;
  background: #ccc; 
  outline: none;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: black;
    border: 6px solid white;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: black;
    border: 6px solid white;
    cursor: pointer;
  }
`;

type SliderProps = {
  spend: number;
  setSpend: (value: number) => void;
  min: number;
  max: number;
  step: number
  easeIn?: boolean;
  background?: boolean;
}

const Slider = ({
  spend,
  setSpend,
  min,
  max,
  step,
  easeIn = false,
  background = false,
}: SliderProps) => {

  return (
    <CalculatorContainer background={background}>
      <SliderWrapper>
        <SliderValue
          position={((spend - min) / (max - min)) * step}
          easeIn={easeIn}
        >
          ${spend}
        </SliderValue>
        <SliderComponent
          type="range"
          min={min}
          max={max}
          step={step}
          value={spend}
          onChange={(e) => setSpend(Number(e.target.value))}
        />
      </SliderWrapper>
    </CalculatorContainer>
  )
}

export default Slider;